import script from "./DurataTable1.vue?vue&type=script&setup=true&lang=js"
export * from "./DurataTable1.vue?vue&type=script&setup=true&lang=js"

import "./DurataTable1.vue?vue&type=style&index=0&id=24dfdbe9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24dfdbe9"]])

export default __exports__